import type { ManualPaymentConfirmRequest } from '@/core/generated/api';
import type { ManualPaymentConfirmFormValues } from './model/manualPaymentConfirmSchema';

/** Собирает запрос ручного подтверждения платежа из формы */
export const manualPaymentConfirmFormToRequest = (
    values: ManualPaymentConfirmFormValues,
): ManualPaymentConfirmRequest => ({
    externalId: values.externalId.trim(),
    robokassaPaymentUrl: values.robokassaPaymentUrl.trim(),
    comment: values.comment.trim(),
});
